import { Error } from '@mui/icons-material';
import { Grid, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { GenConfirmationDialog } from '@pinnacleautomotive/clarity-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function OrderDeclineDialog({
  open,
  onClose,
  onConfirm,
  order,
  processingAction,
  onSuccess,
}) {
  const [observation, setObservation] = useState('');
  const { t } = useTranslation('orders');

  useEffect(() => {
    if (onSuccess) setObservation('');
  }, [onSuccess]);

  return (
    <GenConfirmationDialog
      open={open}
      onClose={onClose}
      onRefuse={onClose}
      isLoading={processingAction}
      onConfirm={() => {
        onConfirm(observation);
      }}
      title={t('workDecline')}
      titleIcon={Error}
      titleIconColor={'error'}
      closeText={t('noWait')}
      confirmText={t('yesDecline')}
    >
      <Grid container direction={'column'} alignItems="center">
        <Grid item width={'100%'}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginBottom="20px"
          >
            <Typography variant="overline">{t('workOrderNumber')}:</Typography>
            <Typography variant="subtitle" marginLeft={'7.5px'}>
              {order?.woNumber}
            </Typography>
          </Box>
          <TextField
            placeholder={t('observationPlaceholder')}
            multiline
            value={observation}
            disabled={processingAction}
            onChange={event => setObservation(event.target.value)}
            rows={3}
            maxRows={4}
            sx={{ width: '100%' }}
          />
        </Grid>
      </Grid>
    </GenConfirmationDialog>
  );
}
